export default {
 template: require('./wtg-account-info.html'),
 bindings: {
  account: "<"
 },
 controller: function($scope,$rootScope) {
  $scope.strings = $rootScope.strings;
 }
};
